<template>
  <div class="items">
    <v-layout v-bind="layout">
      <v-flex xs12 sm6 md8 lg9>
        <template v-for="(item, index) in projects" v-if="item.order_item_ids.length < 1">
          <card :item="item" :index="index" item-type="unordered"></card>
        </template>
        <template v-for="(item, index) in items">
          <card :item="item" :index="index" item-type="ordered"></card>
        </template>
      </v-flex>
      <v-flex xs12 sm6 md4 lg3>
        <cart></cart>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import api from '@/api/gungho'
  import Events from '@/api/events'
  import Cart from '../cart'
  import Card from './card'

  export default {
    metaInfo: {
      title: 'Items'
    },

    data () {
      return {
        items: false,
        projects: false
      }
    },

    computed: {
      layout () {
        const layout = {}
        if (this.$vuetify.breakpoint.smAndDown) layout.column = true
        return layout
      }
    },

    components: {
      cart: Cart,
      card: Card
    },

    beforeMount () {
      api.items().then((data) => {
        this.items = data.items
      })

      api.projects().then(data => {
        this.projects = data.projects
      }).catch(error => {
        console.log(error)
      })

      Events.$on('updateItemsList', (data) => {
        this.updateItem(data)
      })

      Events.$on('deleteItem', (item, index) => {
        api.destroyProject(item.id).then(data => {
          this.projects.splice(index, 1)
          Events.$emit('toast', 'Deleted item')
        }).catch(error => {
          console.log(error)
        })
      })

      Events.$on('updateProjectCart', (project) => {
        this.$store.dispatch('addCartItem', {
          'project_id': project.id,
          'quantity': project.cartQuantity
        })
      })

      Events.$on('updateItemCart', (item) => {
        this.$store.dispatch('addCartItem', {
          'order_item_id': item.id,
          'quantity': item.cartQuantity
        })
      })

      Events.$on('updateItem', (data) => {
        if (!data) return
        if (!this.items) return
        this.items.find(
          (item) => {
            if (item.id === data.order_item_id) {
              this.$set(item, 'cartId', data.id)
              this.$set(item, 'cartQuantity', data.quantity)
              this.$set(item, 'cartUnitPrice', data.unit_price)
              return
            }
          }
        )
      })
    },

    beforeDestroy () {
      Events.$off('updateItemsList')
      Events.$off('deleteItem')
      Events.$off('updateProjectCart')
      Events.$off('updateItemCart')
      Events.$off('updateItem')
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?78bf4e2e